export const plaintext = {
  reports: {
    title: {
      eng: "Reports",
      spa: "Reportes",
      frn: "Rapports",
      por: "Relatórios",
    },
    hi: {
      eng: "Hi",
      spa: "Hola",
      frn: "Bonjour",
      por: "Olá",
    },
    viewAsTitle: {
      eng: "View As",
      spa: "Ver Como",
      frn: "Afficher en tant que",
      por: "Visualizar como",
    },
    embedTitle: {
      eng: "Embed Report",
      spa: "Reporte",
      frn: "Intégrer le rapport",
      por: "Relatório de incorporação",
    },
    noAccess: {
      eng: "You don't have access to any reports",
      spa: "No cuenta con acceso a ningún reporte",
      frn: "Vous n'avez accès à aucun rapport",
      por: "Você não tem acesso a nenhum relatório",
    },
    contactPSC: {
      eng: "Please contact your PSC, PSA, or PSF Administrators below for access.",
      spa: "Comuníquese con su administrador de PSC para poder ingresar:",
      frn: "Veuillez communiquer avec l'administrateur PSC pour obtenir l'accès.",
      por: "Entre em contato com o administrador PSC para obter acesso.",
    },
    contactDM: {
      eng: "Please contact your District Manager for access.",
      spa: "Comuníquese con su Gerente de Distrito para poder ingresar.",
      frn: "Veuillez communiquer avec votre chef régional pour obtenir l'accès.",
      por: "Entre em contato com o seu gerente distrital para obter acesso.",
    },
    pscHelpText: {
      eng: "Missing a report? Contact an administrator.",
      spa: "¿Falta un informe? Comuníquese con un administrador.",
      frn: "Un rapport est absent? Communiquer avec un administrateur.",
      por: "Faltou algum relatório? Entre em contato com um administrador.",
    },
  },
  manageReports: {
    title: {
      eng: "Manage Reports",
      spa: "Administrar Reportes",
      frn: "Gérer les rapports",
      por: "Gerenciar relatórios",
    },
    select: {
      eng: "Select a Report to manage it's permissions.",
      spa: "Seleccione un reporte para administrar sus permisos.",
      frn: "Sélectionner un Rapport pour gérer ses autorisations.",
      por: "Selecione um relatório para gerenciar as permissões dele.",
    },
    manageBtn: {
      eng: "Manage Report",
      spa: "Administrar Reporte",
      frn: "Gérer le rapport",
      por: "Gerenciar relatório",
    },
  },
  manageReportSecurity: {
    ewa: {
      eng: "Employees without access",
      spa: "Empleados sin acceso",
      frn: "Employés sans accès",
      por: "Funcionários sem acesso",
    },
    ewoa: {
      eng: "Employees with access",
      spa: "Países sin acceso",
      frn: "Employés avec accès",
      por: "Funcionários com acesso",
    },
    grant: {
      eng: "Grant",
      spa: "Permitir",
      frn: "Accorder",
      por: "Conceder",
    },
    access: {
      eng: "Access",
      spa: "Acceso",
      frn: "Accès",
      por: "Acesso",
    },
    ra: {
      eng: "Remove Access",
      spa: "Eliminar Acceso",
      frn: "Retirer l'accès",
      por: "Remover acesso",
    },
    ga: {
      eng: "Grant Access",
      spa: "Permitir Acceso",
      frn: "Accorder l'accès",
      por: "Conceder acesso",
    },
    eas: {
      eng: "Employee access added successfully",
      spa: "El acceso del empleado se agregó correctamente",
      frn: "Accès de l'employé ajouté avec succès",
      por: "Acesso de funcionário adicionado com sucesso",
    },
    easPlural: {
      eng: "Employees access added successfully",
      spa: "El acceso de los empleados se agregó correctamente",
      frn: "Accès des employés ajouté avec succès",
      por: "Acesso de funcionários adicionado com sucesso",
    },
    ers: {
      eng: "Employee access removed successfully",
      spa: "El acceso del empleado se remoto correctamente",
      frn: "Accès de l'employé supprimé avec succès",
      por: "Acesso de funcionário removido com sucesso",
    },
    ersPlural: {
      eng: "Employees access removed successfully",
      spa: "El acceso de los empleados se remoto correctamente",
      frn: "Accès des employés supprimé avec succès",
      por: "Acesso de funcionários removido com sucesso",
    },
    failed: {
      eng: "Failed to create security for report. Please try again later.",
      spa: "Por seguridad, no se puede generar el reporte. Por favor, inténtelo de nuevo más tarde.",
      frn: "Échec de la création de la sécurité du rapport. Veuillez réessayer ultérieurement.",
      por: "Falha ao criar segurança para relatório. Tente novamente mais tarde.",
    },
    das: {
      eng: "Dealer access added successfully",
      spa: "Acceso de distribuidores agregado con éxito",
      frn: "Accès du concessionnaire ajouté avec succès",
      por: "Acesso de revendedor adicionado com sucesso",
    },
    dasPlural: {
      eng: "Dealers access added successfully",
      spa: "Accesos de distribuidores agregado con éxito",
      frn: "Accès des concessionnaires ajouté avec succès",
      por: "Acesso de revendedores adicionado com sucesso",
    },
    security: {
      eng: "Security",
      spa: "Seguridad",
      frn: "Sécurité",
      por: "Segur",
    },
  },
  viewReportsOf: {
    title: {
      eng: "View Reports Of",
      spa: "Ver Informes De",
      frn: "Voir les rapports de",
      por: "Visualizar relatórios de",
    },
    employee: {
      eng: "Viewing the reports of employee",
      spa: "Ver Reporte de Empleados",
      frn: "Consultation des rapports d'employé",
      por: "Visualizando os relatórios do funcionário",
    },
    employeeNoAccess: {
      eng: "does not have access to any reports.",
      spa: "no tiene acceso a ningún informe.",
      frn: "n'a accès à aucun rapport.",
      por: "não tem acesso a nenhum relatório.",
    },
    header1: {
      eng: "View which reports an employee",
      spa: "Ver el reporte del empleado",
      frn: "Voir les rapports auxquels un employé",
      por: "Visualizar quais relatórios um funcionário",
    },
    header2: {
      eng: "or dealership",
      spa: "o distribuidor",
      frn: "ou le concessionnaire",
      por: "ou concessionária",
    },
    header3: {
      eng: "can access",
      spa: "puede acceder",
      frn: "peut accéder",
      por: "pode acessar",
    },
  },
  dashboard: {
    title: {
      eng: "My Dashboard",
      spa: "Mi Dashboard",
      frn: "Mon tableau de bord",
      por: "Meu painel",
    },
    navButton: {
      eng: "Dashboard",
      spa: "Dashboard",
      frn: "Tableau de bord",
      por: "Painel",
    },
    ncf: {
      eng: "No Charts Found",
      spa: "No se Encontraron Gráficas",
      frn: "Aucun tableau trouvé",
      por: "Nenhum gráfico encontrado",
    },
  },
  admin: {
    title: {
      eng: "Administrator",
      spa: "Administrador",
      frn: "Administrateur",
      por: "Administrador",
    },
  },
  welcome: {
    eng: "Welcome Back",
    spa: "Hola",
    frn: "Bienvenue",
    por: "Boas-vindas de volta",
  },
  close: {
    eng: "Close",
    spa: "Cerrar",
    frn: "Fermer",
    por: "Fechar",
  },
  go: {
    eng: "Go",
    spa: "Vamos",
    frn: "Aller",
    por: "Ir",
  },
  back: {
    eng: "BACK",
    spa: "REGRESAR",
    frn: "RENDRE",
    por: "VOLTE",
  },
  table: {
    name: {
      eng: "Name",
      spa: "Nombre",
      frn: "Nom",
      por: "Nome",
    },
    zone: {
      eng: "Zone",
      spa: "Región",
      frn: "Zone",
      por: "Área",
    },
    search: {
      eng: "Search by name, id, or role",
      spa: "Buscar por nombre, id o función",
      frn: "Recherche par nom, identifiant ou rôle",
      por: "Pesquise por nome, id ou função",
    },
    roles: {
      eng: "Roles",
      spa: "Funcións",
      frn: "Rôles",
      por: "Funções",
    },
    sbn: {
      eng: "Search by name",
      spa: "Buscar por nombre o función",
      frn: "Recherche par nom",
      por: "Pesquise por nome",
    },
  },
};
